import { queryOptions } from '@tanstack/react-query';

import { queryClient } from '../../router/Root';
import { selectedTeamIdQuery } from '../teamQuery';
import { userQuery } from '../userQuery';

import { getCombinedApprovalsData } from './approvalQuery';

import type { Approval } from '../../repositories/approvalRepository';

const findApprovalById = async (id: Approval['id'] | undefined) => {
	if (!id) {
		return null;
	}

	const user = await queryClient.ensureQueryData(userQuery);
	const teamIdQuery = selectedTeamIdQuery('selectedTeamID');
	const teamId = await queryClient.ensureQueryData(teamIdQuery);
	const approvalsQuery = getCombinedApprovalsData(user, teamId?.[0] || '', false);
	const approvalsData = await queryClient.ensureQueryData({
		queryKey: approvalsQuery.queryKey,
		queryFn: approvalsQuery.queryFn,
	});

	for (const group of Object.keys(approvalsData.groupedApprovals)) {
		const found = approvalsData?.groupedApprovals?.[group].approvals?.find(approval => approval.id === id);
		if (found) {
			return found as Approval;
		}
	}

	const dashboardFound = approvalsData?.approvalsDashBoardCollection?.find(approval => approval.id === id);
	if (dashboardFound) {
		return dashboardFound;
	}

	const approvalInOtherTeamFound = approvalsData?.assignedApprovals?.find(
		approval => approval.id === id && approval.assignees.includes(user?.userId),
	);
	if (approvalInOtherTeamFound) {
		return approvalInOtherTeamFound;
	}

	return null;
};

export const conversationApprovalQuery = (approvalId: string | undefined) => {
	return queryOptions({
		queryKey: ['approval', approvalId],
		queryFn: () => findApprovalById(approvalId),
		enabled: Boolean(approvalId),
	});
};
